import { ArrowRight } from 'lucide-react';

const APP_URL = 'https://app.theonestack.com/build';

export function CTASection() {
  return (
    <section className="relative py-28 sm:py-32 overflow-hidden">
      {/* Background gradient */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, #1a1a1a 0%, #262626 40%, #1a1a1a 100%)',
        }}
      />
      {/* Glow effect */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse 60% 50% at 50% 50%, rgba(249,115,22,0.1) 0%, transparent 70%)',
        }}
      />

      <div className="relative mx-auto max-w-3xl px-6 text-center reveal">
        <h2 className="mb-4 text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
          Ready to Run Your Jobs the Right Way?
        </h2>
        <p className="mx-auto mb-10 max-w-xl text-lg text-zinc-400">
          Your first 14 days are free. No credit card. No software to install. Just open a browser and start building.
        </p>
        <a
          href={APP_URL}
          className="group inline-flex items-center gap-2 rounded-xl bg-orange-500 px-10 py-4 text-lg font-semibold text-white transition hover:bg-orange-600"
        >
          Start Free Trial
          <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-0.5" />
        </a>
        <p className="mt-6 text-xs text-zinc-500">
          Free 14-day trial. No credit card required. Cancel anytime.
        </p>
      </div>
    </section>
  );
}
